import { z } from 'zod';

export interface AppNotification {
  id: string;
  pageId: string | null;
  kind: string;
  title: string;
  body: string;
  url: string;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationList {
  items: AppNotification[];
  unread: number;
  nextCursor: string | null;
}

export const pushSubscriptionSchema = z.object({
  endpoint: z.url().max(2000),
  keys: z.object({ p256dh: z.string().min(1).max(500), auth: z.string().min(1).max(500) }),
});
export type PushSubscriptionInput = z.infer<typeof pushSubscriptionSchema>;

export interface PushConfig {
  enabled: boolean;
  publicKey: string | null;
}
